const config = {
  mainTitle: 'Event Bookings',
  subHeading: 'A page to see event bookings.',
  titleIcon: 'IosBookmarksOutline'
}

export default config;
